/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class CredentialFinding {
  /**
  * The type of credential found (e.g. AWS_SECRET_KEY, GITHUB_TOKEN)
  */
  'credentialType': string;
  /**
  * The location where the credential was found
  */
  'dataLocation': { [key: string]: any; };

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "credentialType",
      "baseName": "credentialType",
      "type": "string",
      "format": ""
    },
    {
      "name": "dataLocation",
      "baseName": "dataLocation",
      "type": "{ [key: string]: any; }",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CredentialFinding.attributeTypeMap;
  }

  public constructor() {
  }
}

